import React from "react";

import CustomTooltip from "./CustomTooltip/CustomTooltip";

const FullScheduleModal = ({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  onEnrollClickHandler,
  isAvailableCountLoading,
  availableSeats,
  isPowerUser,
}) => {
  if (!isOpen) return null;

  const shouldDisableButton = () => {
    if (isPowerUser) {
      return isAvailableCountLoading;
    } else {
      return isAvailableCountLoading || availableSeats;
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div className="popup-header">
          <div className="popup-heading">
            <div className="popup-title">{title}</div>
            <div className="popup-subtitle">{subtitle}</div>
            {isPowerUser && availableSeats && !isAvailableCountLoading && (
              <div
                style={{ fontWeight: "600", fontSize: "14px", color: "red" }}
              >
                The session has been filled!
              </div>
            )}
          </div>

          <div className="popup-btns">
            <button
              className={
                shouldDisableButton(
                  isAvailableCountLoading,
                  availableSeats,
                  isPowerUser,
                )
                  ? "button-disabled"
                  : "button"
              }
              disabled={shouldDisableButton(
                isAvailableCountLoading,
                availableSeats,
                isPowerUser,
              )}
              onClick={onEnrollClickHandler}
              style={{ width: "80%" }}
            >
              Enroll
            </button>

            <CustomTooltip text="Close" placement="top">
              <button className="btn-close" onClick={onClose}></button>
            </CustomTooltip>
          </div>
        </div>
        <div className="full-schedule-info">
          <div className="in_person_modal_note_icon">i</div>
          <span style={{ textDecoration: "underline", paddingRight: "4px" }}>
            If you are unable to make this class,
          </span>
          you may reschedule it after you've enrolled.
        </div>
        <div className="popup-body">{children}</div>
      </div>
    </div>
  );
};

export default FullScheduleModal;
